import React, { useState } from 'react';

import { HvTabs, HvTab } from '@hitachivantara/uikit-react-core';
import config from '../../../../config';
import RolesTab from './RolesTab/RolesTab';
import UsersTab from './UserTab/UserTab';
import InvitationsTab from './InvitationTab/InvitationsTab';

const TenantAdminUserView = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = (_event, newTabIndex) => setTabIndex(newTabIndex);

  return (
    <div className="tenant-admin-panel">
      <HvTabs
        id="tabs-content-change"
        value={tabIndex}
        onChange={handleChange}
      >
        <HvTab
          id="users"
          label="Users"
        />
        {!config.onPremise && (
          <HvTab
            id="invitations"
            label="Invitations"
          />
        )}
        <HvTab
          id="roles"
          label="Roles"
        />
      </HvTabs>
      <div className="tenant-admin-content-tabs-container">
        {tabIndex === 0 && <UsersTab />}
        {!config.onPremise && tabIndex === 1 && <InvitationsTab />}
        {(config.onPremise ? tabIndex === 1 : tabIndex === 2) && <RolesTab />}
      </div>
    </div>
  );
};

export default TenantAdminUserView;
